import React from 'react';
import Content from '../Content/Content';
import styles from './LoaderContent.module.scss';
import cx from 'classnames';
import { useUIContext } from '../../context/UIContext';
import Spinner from '../../../common/components/Spinner';

export const LoaderContent = ({ unmount = false, centralized = false }) => {
  const { miniSidebar } = useUIContext();

  return (
    <Content
      className={cx(styles.content, {
        [styles.miniSidebar]: miniSidebar,
        [styles.unmount]: unmount,
        [styles.centralized]: centralized,
      })}
    >
      <div className={styles.spinnerContainer}>
        <Spinner width={'50px'} height={'50px'} size={'4px'} />
      </div>
    </Content>
  );
};
